export enum ArticleMenu {
  BOTH = 'BOTH',
  BOTTOM_MENU = 'BOTTOM_MENU',
  NONE = 'NONE',
  TOP_MENU = 'TOP_MENU'
}

